// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3RATE","body":"body__HJ-Ap","icon":"icon__h5vCH","title":"title__3THjL","bgImage":"bgImage__3-UzK"};